// Place any jQuery/helper plugins in here.
(function (targetWidth) {
    var deviceWidth = screen.width;
    var ratio = deviceWidth / targetWidth;
    var viewport = document.querySelector('meta[name="viewport"]');
    if (ratio < 1) {
        viewport.setAttribute('content', 'width=device-width, initial-scale=' + ratio + ', minimum-scale=' + ratio + ', maximum-scale=' + ratio + ', user-scalable=yes');
    }
})(375);

$(function () {
    // 錨點
    $('[data-anchor-btn]').on('click.anchor', function (e) {
        e.preventDefault();
        $('html, body').animate({
            scrollTop: $(`#${$(this).data('anchor-btn')}`).offset().top
        }, 300);
        $('body').removeClass('-menuOpen');
    });

    // 選單
    $('[data-burger]').on('click.burger', function () {
        $('body').toggleClass('-menuOpen');
    });

    // popup
    $('[data-popup-btn]').on('click.popup', function () {
        $('body').toggleClass('-popupOpen');
        $('.popup').toggleClass('-show');
    });

    const tabSwiper = new Swiper('[data-slider="tab"]', {
        watchOverflow: true,
        slidesPerView: 1,
        spaceBetween: 40,
        simulateTouch: true,
        loop: false,
        autoHeight: true,
        on: {
            slideChangeTransitionStart: (swiper) => {
                $('[data-tab-btn]').removeClass('-active');
                $('[data-tab-btn="' + (swiper.activeIndex + 1) + '"]').addClass('-active');
            }
        }
    });

    const setting = {
        watchOverflow: true,
        slidesPerView: 'auto',
        spaceBetween: 15,
        simulateTouch: true,
        loop: false,
        centeredSlides: true,
        autoplay: {
            delay: 5000,
            disableOnInteraction: false
        },
        pagination: {
            el: '.swiper-pagination',
            enabled: true,
            clickable: true
        },
        breakpoints: {
            768: {
                simulateTouch: false
            }
        }
    };
    new Swiper('[data-slider="gn"]', setting);
    new Swiper('[data-slider="yl"]', setting);
    new Swiper('[data-slider="pk"]', setting);
    new Swiper('[data-slider="rd"]', setting);
    new Swiper('[data-slider="bu"]', setting);

    // 收合
    $('[data-collapse-action]').on('click', function (e) {
        e.preventDefault();
        $(this).closest('[data-collapse]').toggleClass('is-open').find('[data-collapse-content]').slideToggle();
    });

    // tab
    $('[data-tab-btn]').on('click.tab', function (e) {
        e.preventDefault();
        var val = $(this).data('tabBtn');
        tabSwiper.slideTo(val - 1, 300);
    });
    $('[data-capsule-btn]').on('click.capsule', function (e) {
        e.preventDefault();
        var val = $(this).data('capsuleBtn');
        $('[data-capsule-btn], [data-capsule-content]').removeClass('-active');
        $(this).addClass('-active');
        $('[data-capsule-content="' + val + '"]').addClass('-active');
    });
})